
import { useEffect, useState, useRef } from 'react';
import './AutoCompleteInput.css';
import React from 'react';

const AutoCompleteInput = ({ 
        placeholder, 
        pAllCountries, 
        selCountryId, 
        fnOnChange, 
        index,
        matchingListHeight = 149,
        matchedEltHeight = 37,
        showSearchLine = true,
        showFirstItem,
    }) => {


    const [listClosed, setListClosed] = useState(true);    
    const [text, setText] = useState(pAllCountries.filter(c => c.Id === parseInt(selCountryId))[0].Name);
    const [countryId, setCountryId] = useState(selCountryId); // old code
    //const [countryId, setCountryId] = useState(parseInt(selCountryId)); 
    //console.log("selCountryId", selCountryId, typeof(selCountryId));

    const countriesDivs = useRef(null);
    const countryInput = useRef(null);
    const countriesBox = useRef(null);

    useEffect(() => {
        setCountryId(selCountryId);  // old code
        //setCountryId(parseInt(selCountryId));
    }, [selCountryId]);

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
    }, []);


    const handleOutsideClick = (e) => {
        if (countryInput.current && countryInput.current.contains(e.target)) { 
            const divs = document.getElementsByClassName("matching-list"+index);
            return;
        }
        if (countriesDivs.current && !countriesDivs.current.contains(e.target)) { 
            const divs = document.getElementsByClassName("matching-list"+index);
            if(divs && !divs[0].classList.contains("hide"))
                divs[0].classList.add("hide");
        }
    }

    const [allCountries, setAllCountries] = useState(pAllCountries);

    const [matchingList, setMatchingList] = useState(
        showFirstItem ? 
        [...pAllCountries]
        :
        [...pAllCountries.filter(c => c.Id !== 0)]
    );

    const findMatchedElt = (event) => {
        if(!showFirstItem)
            setMatchingList(pAllCountries.filter(el => el.Name
                                                    .toLowerCase()
                                                    .indexOf(event.target.value.toLowerCase()) >= 0 && el.Id !== 0));
        else
            setMatchingList(pAllCountries.filter(el => el.Name
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) >= 0));

        setText(event.target.value.toLowerCase());
        //setListClosed(false);
    }

    const setCountryObject = (_country, index) => {
        //console.log(_country.Id);
        fnOnChange(_country.Id);
        setCountryId(_country.Id);
        setText(_country.Name);
        //setListClosed(true);

        const divs = document.getElementsByClassName("matching-list"+index);
        if(divs && divs[0])
            divs[0].classList.add("hide");
    }

    const deleteText = () => {
        setText("");
        setCountryId(null);
        //setListClosed(true);
    }
    
    
    const hideList = (index) => {
        const divs = document.getElementsByClassName("matching-list"+index);
        if(divs && divs[0])
            divs[0].classList.add("hide");
    }

    const displayAllCountries = (index) => {

        // Don't allow user to open "Countries" list until the list is loaded
        if(!pAllCountries || pAllCountries.length <= 1)
            return;

        setText("");
        if(!showFirstItem) {
            //setMatchingList([...allCountries.filter(c => c.Id !== 0)]);   // old code (It was not refreshing the list)
            setMatchingList([...pAllCountries.filter(c => c.Id !== 0)]);
        }
        else {
            //setMatchingList([...allCountries]);   // old code (It was not refreshing the list)
            setMatchingList([...pAllCountries]);
        }
        const divs = document.getElementsByClassName("matching-list"+index);
        if(divs) {
            if(divs[0].classList.contains("hide")) {
                divs[0].classList.remove("hide");
            }
            else {
                divs[0].classList.add("hide");
            }
        }

        if(countriesBox) {
            countriesBox.current.scroll({
                top: 0,
            });
        }

        const searchInput = document.getElementsByClassName("search-input"+index);
        if(searchInput && searchInput[0]) {
            searchInput[0].focus();
        }
    }

    return (
        <>  
            <div className='auto-complete-container'>

                {/* <div className={`indicator background-red ${ !country ? "background-red" : "background-green" }`}>
                </div> */}
            
                {/* <i className='fa fa-plane img-icon'></i> */}

                {/* {
                    country && 
                    <img src={ "/" + country.LogoFileName } 
                         alt={ country.LogoFileName } 
                         style={{     width: '30px',
                                    height: '30px',
                                    marginLeft: '10px',
                                    position: 'absolute' }}/>
                } */}
                
                {/* <img src={ alarm } alt="ssss" className='img-icon'/> */}
                    {/* founded ? 
                    "C:\\Users\\user\\Desktop\\alarm.png" : 
                    "C:\\Users\\user\\Desktop\\alarm.png"
                    } alt="airplane"/> */}

                <div className='component'>
                    <div className='value-container input' 
                         ref={ countryInput } 
                         onClick={ () => displayAllCountries(index) } 
                         style={{ cursor:  pAllCountries.length <= 1 ? 'default' : 'pointer' }}>
                            
                            <div style={{ width: "100%",}}>
                            { 
                                pAllCountries &&
                                pAllCountries.filter(c => c.Id === parseInt(countryId))[0] ? 
                                pAllCountries.filter(c => c.Id === parseInt(countryId))[0].Name
                                : 
                                0
                            }
                            </div>
                            <div>
                                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                            </div>
                    </div>
                    <div className={`matching-list${index} hide`} 
                         style={{
                            height: `${matchingListHeight}px`,
                            // minHeight: { matchingListHeight } + "px",
                            // maxHeight: { matchingListHeight } + "px",
                          }}
                         ref={ countriesDivs }>
                            <div className={`search-line ${ showSearchLine ? '' : 'totally-hide' }`}>
                                <i id="specific-search" className="fa fa-search" aria-hidden="true"></i>
                                <input className={`search-input${index} input`} 
                                    value={ text }
                                    type="text"
                                    // onBlur={ hideList(index) }
                                    onChange={ (e) => findMatchedElt(e) }
                                    placeholder={ placeholder }
                                    autoFocus />
                            </div>
                    
                        <div className='only-countries' ref={ countriesBox }>
                            {   
                                matchingList && 
                                Array.isArray(matchingList) && 
                                matchingList.map((a, key) => {
                                    return(
                                            <div className='matched-elt' 
                                                style={{ 
                                                    height: `${matchedEltHeight}px`,
                                                 }}
                                                key={ key }
                                                onClick={ () => setCountryObject(a, index)} >
                                                
                                                <div className='row-1'>
                                                    {/* <div>
                                                        <img src="https://flagcdn.com/lb.svg" 
                                                            alt="leb_flag" 
                                                            className='flag' />
                                                    </div> */}
                                                    <div className='country-name'>
                                                        { a.Name }
                                                    </div>
                                                </div>

                                                {
                                                    matchedEltHeight === 37 ? 
                                                    <></>
                                                    :
                                                    a.details ?
                                                    <div className='row-2'>
                                                        <div className='circle'></div>
                                                        <div>{ a.details }</div>
                                                        
                                                        {/* <div>{ a.details.split("_")[0] }</div> */}
                                                        {/* <div style={{ color: "#c1c1c1", fontWeight: "400" }}>
                                                            { a.details.split("_")[1] }
                                                        </div> */}
                                                    </div>
                                                    :
                                                    <>
                                                        {/* Please wait... */}
                                                    </>
                                                }

                                            </div>                    
                                        )
                                    })
                            }
                        </div>
                    </div>
                </div>
                
                { 
                    text !== "" ?
                    <i className="fa fa-times x-icon" 
                       aria-hidden="true" 
                       onClick={ deleteText } ></i>
                    : ""
                }

            </div>
        </>
    );
}

export default AutoCompleteInput;